export * from "./collect-stream-body";
export * from "./extended-encode-uri-component";
export * from "./HttpBindingProtocol";
export * from "./HttpProtocol";
export * from "./RpcProtocol";
export * from "./requestBuilder";
export * from "./resolve-path";
export * from "./serde/FromStringShapeDeserializer";
export * from "./serde/HttpInterceptingShapeDeserializer";
export * from "./serde/HttpInterceptingShapeSerializer";
export * from "./serde/ToStringShapeSerializer";
export * from "./serde/determineTimestampFormat";
export * from "./SerdeContext";
export { Field } from "./protocol-http/Field";
export { Fields } from "./protocol-http/Fields";
export { HttpRequest } from "./protocol-http/httpRequest";
export { HttpResponse } from "./protocol-http/httpResponse";
export { isValidHostname } from "./protocol-http/isValidHostname";
export { getHttpHandlerExtensionConfiguration, resolveHttpHandlerRuntimeConfig, } from "./protocol-http/extensions/httpExtensionConfiguration";
export { contentLengthMiddleware, contentLengthMiddlewareOptions, getContentLengthPlugin, } from "./middleware-content-length/contentLengthMiddleware";
export { escapeUri } from "./util-uri-escape/escape-uri";
export { escapeUriPath } from "./util-uri-escape/escape-uri-path";
export { buildQueryString } from "./querystring-builder/buildQueryString";
export { parseQueryString } from "./querystring-parser/parseQueryString";
export { parseUrl } from "./url-parser/parseUrl";
